import React from 'react'
import { Box } from '@node-space/ui-components'
import { DisplayPreferences } from './components/DisplayPreferences'
import { PersonalDetails } from './components/PersonalDetails'
import { Security } from './components/Security'

const UserDetails = () => {
  return (
    <Box gap={24} className="grid gap-8 grid-cols-1 md:grid-cols-[370px_370px]">
      <PersonalDetails />
      <Box flexCol gapY={24}>
        <DisplayPreferences />
        <Security />
      </Box>
    </Box>
  )
}

export default UserDetails
